import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { I18NEXT_NAMESPACE, I18NextModule } from 'angular-i18next';

import { HbSharedModule } from '../shared/hb-shared.module';
import { HbSharedUiModule } from '../shared/ui/hb-shared-ui.module';
import { AboutDialogComponent } from './about-dialog.component';
import { AboutComponent } from './about.component';

@NgModule({
  imports: [
    CommonModule,
    HbSharedModule,
    HbSharedUiModule,
    I18NextModule.forRoot(),
  ],
  declarations: [
    AboutComponent,
    AboutDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: I18NEXT_NAMESPACE,
      useValue: ['module.about', 'module.hb-shared', 'module.hb-shared-ui', 'languages', 'module.licensing'],
    },
  ],
  exports: [
    AboutComponent,
  ],
  bootstrap: [
    AboutDialogComponent,
  ],
})
export class AboutModule { }
